/* eslint-disable camelcase */
import React, { useState } from 'react'

import { useFormik } from 'formik'
import * as yup from 'yup'
import { useDelete, usePost } from '../../hooks/useXHR'
import {
  Button,
  ButtonWrapper,
  FormColumn,
  FormGroup,
  FormRow,
  Modal
} from '../../ui'
import { TextField, Uploader, ConfirmationDialog } from '..'
const ENDPOINT_BRANDS = '/brands.php'

interface BrandProps {
  id_brands: string
  name: string
  logo: string
  url: string
  activate: string
  update: string
}

interface ModalProps {
  value: BrandProps
  onClose: () => void
  onChange: () => void
}

export const BrandModal: React.FC<ModalProps> = ({
  value,
  onClose,
  onChange
}) => {
  const [deleteDialog, setDeleteDialog] = useState<boolean>(false)
  const { action: post } = usePost()
  const { action: removeBrand } = useDelete()

  const validationSchema = yup.object().shape({
    name: yup.string().required('Esse campo é obrigatório').trim(),
    logo: yup.string().required('Esse campo é obrigatório'),
    url: yup.string().required('Esse campo é obrigatório')
  })

  const {
    errors,
    touched,
    values,
    getFieldProps,
    isValid,
    setFieldValue,
    setFieldTouched,
    validateForm,
    handleSubmit
  } = useFormik({
    initialValues: value,
    validationSchema,
    enableReinitialize: true,
    isInitialValid: validationSchema.isValidSync(value),
    validateOnBlur: true,
    validateOnMount: true,
    validateOnChange: true,
    onSubmit: formValues => {
      const { name, logo, url } = formValues
      post(ENDPOINT_BRANDS, {
        id_brands: value.id_brands,
        name,
        logo,
        url
      }).then(() => {
        onChange()
      })
    }
  })

  const handleDelete = () => {
    removeBrand(ENDPOINT_BRANDS, {
      id_brands: value.id_brands
    })
      .then(() => {
        onChange()
      })
      .catch(err => console.debug(err))
  }

  const handleImageUpload = (file: string) => {
    setFieldValue('logo', file)
    setFieldTouched('logo', true, false)
    validateForm({ ...values, logo: file })
  }

  const canPost = (): boolean => {
    const { name, logo, url } = values
    if (name !== value.name) return true
    if (logo !== value.logo) return true
    if (url !== value.url) return true
    return false
  }

  return (
    <>
      <Modal title="Editar marca" onClose={onClose} showCloseButton>
        <form onSubmit={handleSubmit}>
          <FormRow>
            <FormColumn>
              <TextField
                label="Nome da marca"
                {...getFieldProps('name')}
                error={errors.name && touched.name ? errors.name : ''}
              />
            </FormColumn>
          </FormRow>
          <FormRow>
            <FormColumn>
              <TextField
                label="Link para o site da marca"
                {...getFieldProps('url')}
                error={errors.url && touched.url ? errors.url : ''}
              />
            </FormColumn>
          </FormRow>
          <FormRow>
            <FormColumn>
              <FormGroup
                title="Logotipo da marca"
                error={errors.logo && touched.logo ? errors.logo : ''}
              >
                <Uploader
                  onUpload={handleImageUpload}
                  accept={['image/png', 'image/jpg', 'image/jpeg']}
                  {...getFieldProps('logo')}
                />
              </FormGroup>
            </FormColumn>
          </FormRow>
          <FormRow>
            <FormColumn>
              <ButtonWrapper>
                <Button
                  danger
                  type="button"
                  onClick={() => setDeleteDialog(true)}
                >
                  Excluir
                </Button>
                <Button type="submit" primary disabled={!isValid || !canPost()}>
                  Salvar alterações
                </Button>
              </ButtonWrapper>
            </FormColumn>
          </FormRow>
        </form>
      </Modal>
      {deleteDialog && (
        <ConfirmationDialog
          title="Excluir marca?"
          onCancel={() => setDeleteDialog(false)}
          onConfirm={handleDelete}
        />
      )}
    </>
  )
}
